export default __webpack_public_path__ + "static/media/line.56cc25f2.svg";